// mutation-types.js
export const FETCH_PRESSLIST = 'FETCH_PRESSLIST';